export default () => {
    const bgList = document.querySelectorAll('.lazy-bg');
    Array.prototype.forEach.call(bgList, (bg) => {
        if (bg.getAttribute('data-bg') !== null) {
            const imgBg = new Image();
            imgBg.src = bg.getAttribute('data-bg');
            imgBg.onload = () => {
                bg.classList.add('lazy-bg-done');
                setTimeout(() => {
                    bg.style.backgroundImage = `url(${imgBg.src})`;
                }, 400);         
            }
        }
    })
    
    const imgList = document.querySelectorAll('img[data-src]');
    Array.prototype.forEach.call(imgList, (image) => {
        if (image.getAttribute('data-src') !== null) {
            image.setAttribute('src', image.getAttribute('data-src'))
            // image.removeAttribute('data-src')
        }

        if (image.getAttribute('data-srcset') !== null) {
            image.setAttribute('srcset', image.getAttribute('data-srcset'))
            image.removeAttribute('data-srcset')
        }

        if (image.getAttribute('data-sizes') !== null) {
            image.setAttribute('sizes', image.getAttribute('data-sizes'))
            image.removeAttribute('data-sizes')
        }

        if (image.getAttribute('data-alt') !== null) {
            image.setAttribute('alt', image.getAttribute('data-alt'))
            image.removeAttribute('data-alt')
        }

        image.onload = () => {
            image.setAttribute('data-loaded', true);
        }
    })
}